import { render } from "./Homepage.vue?vue&type=template&id=a2e1375e&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=a2e1375e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e1375e"]])

export default __exports__